import React from 'react';
import PropTypes from 'prop-types';

const FormItem = ({ valign, label, children, className }) => (
  <div className={`form-item form-item-v-${valign} ${className || ''}`}>
    <label>{label}</label>
    <div className="form-item-content">{children}</div>
  </div>
);

FormItem.propTypes = {
  valign: PropTypes.oneOf(['center', 'start']),
  label: PropTypes.string
};

FormItem.defaultProps = {
  valign: 'start'
};

export default FormItem;



// WEBPACK FOOTER //
// ./src/components/FormItem.js